import { CaseStatuses, RequestTypeCode } from 'utils/enums';

export function getFirstWidgetSymbolsOrder(
  statuses: CaseStatuses | null | undefined
): {
  order: string[];
  green: string[];
  blue: string[];
  red: string[];
} {
  switch (statuses) {
    case CaseStatuses.InHandling:
      return {
        order: ['Vastaanotettu', 'Käsittelyssä', 'Valmis'],
        green: ['Vastaanotettu'],
        blue: ['Käsittelyssä', 'Valmis'],
        red: [],
      };
    case CaseStatuses.InProgress:
      return {
        order: ['Vastaanotettu', 'Käsittelyssä', 'Valmis'],
        green: ['Käsittelyssä'],
        blue: ['Vastaanotettu', 'Valmis'],
        red: [],
      };
    case CaseStatuses.Completed:
      return {
        order: ['Vastaanotettu', 'Käsittelyssä', 'Valmis'],
        green: ['Valmis'],
        blue: ['Vastaanotettu', 'Käsittelyssä'],
        red: [],
      };
    case CaseStatuses.Canceled:
      return {
        order: ['Vastaanotettu', 'Käsittelyssä', 'Peruttu'],
        green: [],
        blue: ['Vastaanotettu', 'Käsittelyssä'],
        red: ['Peruttu'],
      };
    default:
      return {
        order: [],
        green: [],
        blue: [],
        red: [],
      };
  }
}

export function getSecondWidgetSymbolsOrder(
  statuses: CaseStatuses | null | undefined
): {
  order: string[];
  green: string[];
  blue: string[];
  red: string[];
} {
  switch (statuses) {
    case CaseStatuses.InHandling:
      return {
        order: ['Vastaanotettu', 'Hyväksytty', 'Työn alla', 'Valmis'],
        green: ['Vastaanotettu'],
        blue: ['Hyväksytty', 'Työn alla', 'Valmis'],
        red: [],
      };
    case CaseStatuses.Approved:
      return {
        order: ['Vastaanotettu', 'Hyväksytty', 'Työn alla', 'Valmis'],
        green: ['Hyväksytty'],
        blue: ['Vastaanotettu', 'Työn alla', 'Valmis'],
        red: [],
      };
    case CaseStatuses.InProgress:
      return {
        order: ['Vastaanotettu', 'Hyväksytty', 'Työn alla', 'Valmis'],
        green: ['Työn alla'],
        blue: ['Vastaanotettu', 'Hyväksytty', 'Valmis'],
        red: [],
      };
    case CaseStatuses.Completed:
      return {
        order: ['Vastaanotettu', 'Hyväksytty', 'Työn alla', 'Valmis'],
        green: ['Valmis'],
        blue: ['Vastaanotettu', 'Hyväksytty', 'Työn alla'],
        red: [],
      };
    case CaseStatuses.Canceled:
      return {
        order: ['Vastaanotettu', 'Hyväksytty', 'Työn alla', 'Peruttu'],
        green: [],
        blue: ['Vastaanotettu', 'Hyväksytty', 'Työn alla'],
        red: ['Peruttu'],
      };
    case CaseStatuses.Rejected:
      return {
        order: ['Vastaanotettu', 'Hyväksytty', 'Työn alla', 'Hylätty'],
        green: [],
        blue: ['Vastaanotettu', 'Hyväksytty', 'Työn alla'],
        red: ['Hylätty'],
      };
    default:
      return {
        order: [],
        green: [],
        blue: [],
        red: [],
      };
  }
}

export function isIncident(requestType: RequestTypeCode) {
  return (
    requestType !== RequestTypeCode.KeyOrder &&
    requestType !== RequestTypeCode.PTS &&
    requestType !== RequestTypeCode.SpaceRenovationRequest
  );
}

export function isRepair(requestType: RequestTypeCode) {
  return requestType === RequestTypeCode.SpaceRenovationRequest;
}

export function isKeyOrder(requestType: RequestTypeCode) {
  return requestType === RequestTypeCode.KeyOrder;
}
